import { useState } from 'react';

import { Scene, Stage } from '@/components/Stage/Stage';
import { cn } from '@/lib/cn';
import { SignalsPage } from '@/pages/workspace/signals';
import { isProdMode } from '@/utils/environment';

import { BaseTableTest } from './BaseTableTest';
import { ButtonTest } from './ButtonTest';
import ExpWelcome from './ExpWelcome';
import HeySynclyTest from './HeySynclyTest';
import { TimeTest } from './TimeTest';
import { TreeTest } from './TreeTest';

const routes = [
  {
    route: 'Welcome',
    Component: ExpWelcome,
  },
  {
    route: 'hey-syncly',
    Component: HeySynclyTest,
  },
  {
    route: 'time',
    Component: TimeTest,
  },
  {
    route: 'button',
    Component: ButtonTest,
  },
  {
    route: 'tree',
    Component: TreeTest,
  },
  {
    route: 'base-table',
    Component: BaseTableTest,
  },
  {
    route: 'signals',
    Component: SignalsPage,
  },
];

const ExpPage = () => {
  if (isProdMode())
    throw new Error('This page is only available in development mode');
  const [currRoute, setCurrRoute] = useState<string>('Welcome');
  return (
    <div className="flex h-screen overflow-hidden">
      <div className="flex h-screen w-40 flex-col gap-1 border-r p-2">
        {routes.map((route) => (
          <button
            key={route.route}
            onClick={() => setCurrRoute(route.route)}
            className={cn(
              'cursor-pointer rounded-md px-2 py-1.5 text-left text-sm text-gray-600',
              'transition-all duration-200 hover:bg-gray-200/80',
              {
                'bg-gray-200 text-gray-900 hover:bg-gray-300/80':
                  currRoute === route.route,
              },
            )}
          >
            {route.route}
          </button>
        ))}
      </div>
      <Stage>
        {routes.map((route) => (
          <Scene
            key={route.route}
            status={currRoute === route.route}
            className="h-screen flex-1 overflow-y-auto p-4"
          >
            <route.Component />
          </Scene>
        ))}
      </Stage>
    </div>
  );
};

export default ExpPage;
